import {MessageLogger} from "./MessageLogger";
import {TakipAcStatusEnum} from "./parser/TakipAcStatusEnum";
import app from "@/main";
import {Mixins} from "./Mixins";
import {EvrakGonderCevap} from "../uyap/DosyaAcilisEvrakGonder";
import {matchUyapError} from "../uyap/uyapErrorMatchers";
import TakipSenkronize from "./TakipSenkronize";
import UyapTakipTalebiContent from "./UyapTakipTalebiContent";

export default class TakipAcInjectable extends MessageLogger {
    status: TakipAcStatusEnum = TakipAcStatusEnum.QUERY_PENDING;
    imzasizUdf !: Blob;
    imzaliUdf !: Blob;
    vekalet !: Blob;
    takipAcilisEvraklariResponse!: EvrakGonderCevap;

    takipBilgileri = {
        dosyaEsasNo: "",
        icraDairesi: ""
    };
    dayanaklar: Blob[] = []

    constructor() {
        super();
    }

    setStatus(status: TakipAcStatusEnum) {
        this.status = status;
    }

    mukerrerDosyaKontrol(hash: string, type: "xml" | "uyap"): Promise<any> {
        return new Promise(async (resolve, reject) => {
            //        //this.hashObj, this.tarafList, this.toplamTakibeEsasMiktar
            try {
                let isMukerrer: {
                    success: boolean,
                    message: string,
                    data: {
                        dosya: any | null
                    }
                } = await app.$http.post('/api/v1/hash-kontrol/' + type, {
                    hash: hash,
                    type: type,
                });
                if (isMukerrer.success == true)
                    return resolve({});
                else {
                    return reject({
                        message: ('Seçili takip daha önce tevzi almıştır.Sağda bulunan çöp kutusundan takibi siliniz.'),
                        hash,
                        dosya: isMukerrer.data.dosya
                    });
                }
            } catch (e) {
                return reject({message: ("Hash sorgulanamadı. " + e.message)});
            }
        })
    }


    mukerrerDosyaKontrolFromTakipTalebi(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let parsedContent: any = await TakipSenkronize.parseContentXml(this.imzasizUdf);
                console.log("TakipSenkronize.parseContentXml",parsedContent);
                let uyapTakipTalebiContent = UyapTakipTalebiContent.parse(parsedContent);
                console.log("UyapTakipTalebiContent.parse", uyapTakipTalebiContent);
                let isMukerrer: {
                    success: boolean,
                    message: string,
                    data: {
                        dosya: any | null
                    }
                } = await app.$http.post('/api/v1/hash-kontrol/uyap', {
                    hash: uyapTakipTalebiContent.hash,
                    type: 'uyap',
                });
                if (isMukerrer.success == true)
                    return resolve({});
                else {
                    return reject({
                        message: ('Seçili takip daha önce tevzi almıştır.Sağda bulunan çöp kutusundan takibi siliniz.'),
                        hash: uyapTakipTalebiContent.hash,
                        dosya: isMukerrer.data.dosya
                    });
                }
            } catch (e) {
                console.error("mukerrerDosyaKontrolFromTakipTalebi", e);
                return resolve({});
                return reject({message: ("Hash sorgulanamadı. " + e.message)});
            }
        })
    }

    hashSil(hash: string, type: "xml" | "uyap"): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                await app.$http.delete('/api/v1/hash-kontrol/' + type + '/' + hash);
                return resolve({message: 'Hash başarıyla silindi.'});
            } catch (e) {
                return reject({message: 'Hash silinirken hata oluştu: ' + e.message});
            }
        })
    }


    async setTakipBilgileriToIcraPro(dosyaBilgileri: any, birimID: string= ""): Promise<void> {
        let dosyaBelirleyici = dosyaBilgileri.dosyaBelirleyici;
        if(dosyaBilgileri.isIcraProXml()){
            return app.$imza.icrapro80VeriAktar(this.takipBilgileri.dosyaEsasNo,this.takipBilgileri.icraDairesi,dosyaBelirleyici.id,dosyaBelirleyici.klasor);
        }
        else if(dosyaBilgileri.isIcraProWebXml()){
            try{
                if(dosyaBelirleyici?.id > 0){
                    const araResponse = await app.$http.post<{
                        found: boolean;
                        data: { id: number } | null;
                    }>("/api/v1/icra-dairesi/ara",{
                        uyap_birim_id: birimID,
                        icra_dairesi_isim: this.takipBilgileri.icraDairesi,
                    });
                    const araBody = araResponse.data;
                    const patchPayload: { dosya_esas_no: string; icra_dairesi_id?: number } = {
                        dosya_esas_no: this.takipBilgileri.dosyaEsasNo,
                    };
                    if (araBody.found === true && araBody.data != null && araBody.data.id != null) {
                        patchPayload.icra_dairesi_id = araBody.data.id;
                    }
                    return app.$http.patch("/api/v1/takip/"+dosyaBelirleyici.id+"/dosya-esas-no-icra-dairesi",patchPayload);
                }
            }catch (e) {
                console.log("e",e);
                return;
            }
        }

        return;
    }

    async getImzasizUdfFromUyap(dosyaId: string): Promise<void> {
        if (!this.imzasizUdf) {
            let takibTalebi = await app.$uyap.TakipTalebiIndir(dosyaId)
                .run({
                    download: true,
                    filename: "takip_talebi.udf"
                });
            this.imzasizUdf = takibTalebi.file;
        }
        // eslint-disable-next-line no-console
        console.log("this.imzasizUdf", this.imzasizUdf);
    }

    async mtsGetImzasizUdfFromUyap(dosyaId: string): Promise<void> {
        if (!this.imzasizUdf) {
            let takibTalebi = await app.$uyap.MtsTakipTalebiIndir()
                .run({
                    dosyaId: dosyaId
                });
            this.imzasizUdf = takibTalebi.file;
        }
        // eslint-disable-next-line no-console
        console.log("this.imzasizUdf", this.imzasizUdf);
    }

    setTakipBilgileriFromTakipAcilisEvraklariResponse(): Promise<any> {
        try {
            let div = document.createElement("div");
            // eslint-disable-next-line no-console
            console.log("takipAcilisEvraklariResponse",this.takipAcilisEvraklariResponse);
            div.innerHTML = this.takipAcilisEvraklariResponse.message;
            let nodeList = div.querySelectorAll("strong");
            if (nodeList.length == 0)
                return Promise.reject({message: "Takip açılış yapılamadı !"});
            this.takipBilgileri.icraDairesi = nodeList[0].innerHTML;
            this.takipBilgileri.dosyaEsasNo = nodeList[1].innerHTML;
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    }



    async takipAcilisEvraklariniGonder(tevziDosyaId: string,isMts: boolean = false): Promise<EvrakGonderCevap> {
        try {
            await this.dokumanImzala();
            if (!app.$store.getters.isEicraproDevMode && (!this.imzaliUdf || this.imzaliUdf.size === 0)) {
                throw new Error("Takip talebi imzalanamadı. imzaliUdf boş.");
            }
            let formData: any;
            if(isMts)
                formData = this.getDosyaAcilisEvraklarFormDataForMts(tevziDosyaId);
            else
                formData = this.getDosyaAcilisEvraklarFormData(tevziDosyaId);
            console.log("FormData entries:");
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            let evraklarResult = await app.$uyap.DosyaAcilisEvrakGonder().run(
                {
                    formData: true,
                    data: formData
                })
            this.addMessage('success', "Dosya açılış evrakları gönderildi.");
            this.takipAcilisEvraklariResponse = evraklarResult;
            return Promise.resolve(evraklarResult);
        } catch (e) {
            this.setStatus(TakipAcStatusEnum.OPEN_FAIL);
            // UYAP hata yönlendirmesi (ör. evrak gönderme aksaklığı) varsa ham metin yerine yönlendirici mesaj göster.
            const yonlendirme = matchUyapError(e);
            this.addMessage('error', yonlendirme ? yonlendirme.userMessage : e.message);
            return Promise.reject(e)
        }
    }

    getDosyaAcilisEvraklarFormDataForMts(tevziDosyaId: any): FormData {
        //acilisda mandatory true gidiyor ///
        let gonderilecekEvraklar = {
            "tur": "",
            "turAciklama": "",
            "dosyaId": tevziDosyaId,
            "esasNo": "",
            "data": [
                {
                    "tur": "ICR_TAKIP_TLP",
                    "turAciklama": "Takip Talebi",
                    "aciklama": "Takip Talebi",
                    "evrak": this.imzaliUdf,
                    "dosyaEkEvrak": []
                },
                {
                    "tur": "CZM_VEKALETNAME",
                    "turAciklama": "Vekaletname",
                    "aciklama": "Vekaletname",
                    "evrak": this.getVekaletBlob(),
                    "dosyaEkEvrak": []
                }]
        };
        this.getDayanaklarBlobArray().forEach((dayanakBlob) => {
            gonderilecekEvraklar.data.push(
                {
                    "tur": "MTS_TAKIBIN_DAYANAGI",
                    "turAciklama": "Takibin Dayanağı",
                    "aciklama": "Takibin Dayanağı",
                    "evrak": dayanakBlob,
                    "dosyaEkEvrak": []
                }
            );
        })
        // eslint-disable-next-line no-console
        console.log("gonderilecekEvraklar", gonderilecekEvraklar);
        let evraklar: any[] = gonderilecekEvraklar.data;
        let items: any[] = [];
        let anaEvrakCounter = 1;
        let counter = 1;
        let form = new FormData();
        let defaultTurlist = [
            ".udf",
            ".pdf",
            ".jpg",
            ".jpeg",
            ".png",
            ".tif",
            ".tiff",
            ".UDF",
            ".PDF",
            ".JPG",
            ".JPEG",
            ".PNG",
            ".TIF",
            ".TIFF"
        ];
        let takipTalebiTurList = [
            ".jpg",
            ".udf",
            ".JPG",
            ".UDF"
        ];
        let turList = [];
        let ekEvrakTurList = [];
        evraklar.forEach((evrak, i) => {
            let evrakName = "evrak_" + anaEvrakCounter + ".udf";
            if (typeof evrak.evrak.name != "undefined") {
                evrakName = evrak.evrak.name;
            } else {
                let fileExt = Mixins.getFileExtension(evrak.evrak.type);
                evrakName = "dosya_" + i + "." + fileExt;
            }
            if (evrak.tur == "ICR_TAKIP_TLP") {
                turList = [".udf",".UDF"];
                ekEvrakTurList = takipTalebiTurList;
                evrak.aciklama = "";
            } else {
                turList = defaultTurlist;
                ekEvrakTurList = defaultTurlist;
            }
            items.push({
                id: (new Date()).getTime(),
                evrakTuruOptionDVO: {
                    tur: evrak.tur,
                    label: evrak.turAciklama,
                    mandatory: true,
                    max: 1,
                    ekEvrakMax: 5,
                    acceptTypeList: turList,
                    ekEvrakAcceptTypeList: ekEvrakTurList,
                },
                tur: evrak.tur,
                turAciklama: evrak.turAciklama,
                mandatory: true,
                file: {},
                path: "C:\\fakepath\\" + evrakName,
                kullaniciEvrakAciklama: evrak.aciklama,
                parentId: -1,
                isVekalet: false,
                isVekaletBilgiFormu: false,
                fileId: anaEvrakCounter
            });
            // eslint-disable-next-line no-console
            console.log("EKLENEN EVRAK ", evrak.evrak);
            form.append("file_" + anaEvrakCounter, evrak.evrak, evrakName);
            // eslint-disable-next-line no-console
            console.log("F append => ", "file_" + anaEvrakCounter, evrak.evrak, evrakName);
            counter++;
            anaEvrakCounter = counter;
        })
        form.append("items", JSON.stringify(items));
        form.append("dosyaId", tevziDosyaId);
        return form;
    }

    getDosyaAcilisEvraklarFormData(tevziDosyaId: any): FormData {
        const defaultTurList = [
            ".udf", ".pdf", ".jpg", ".jpeg", ".png", ".tif", ".tiff",
            ".UDF", ".PDF", ".JPG", ".JPEG", ".PNG", ".TIF", ".TIFF"
        ];
        const ekEvrakTurList = [
            ".udf", ".pdf", ".jpg", ".png", ".jpeg", ".image/jpg", ".image/jpeg",
            ".tif", ".tiff", ".UDF", ".JPG", ".JPEG", ".PNG", ".PDF", ".TIF", ".TIFF"
        ];

        const gonderilecekEvraklar: any[] = [
            {
                tur: "ICR_TAKIP_TLP",
                turAciklama: "Takip Talebi",
                aciklama: "Takip Talebi",
                evrak: this.imzaliUdf,
                dosyaEkEvrak: [],
                acceptTypeList: [".udf", ".UDF"],
                mandatory: true
            },
            {
                tur: "CZM_VEKALETNAME",
                turAciklama: "Vekaletname",
                aciklama: "Vekaletname",
                evrak: this.getVekaletBlob(),
                dosyaEkEvrak: [],
                acceptTypeList: defaultTurList,
                mandatory: true
            }
        ];

        this.getDayanaklarBlobArray().forEach((dayanakBlob) => {
            gonderilecekEvraklar.push({
                tur: "MTS_TAKIBIN_DAYANAGI",
                turAciklama: "Takibin Dayanağı",
                aciklama: "Takibin Dayanağı",
                evrak: dayanakBlob,
                dosyaEkEvrak: [],
                acceptTypeList: defaultTurList,
                mandatory: false
            });
        });

        const items: any[] = [];
        let fileCounter = 1;
        const form = new FormData();

        gonderilecekEvraklar.forEach((evrak, i) => {
            const evrakName = typeof evrak.evrak.name !== "undefined"
                ? evrak.evrak.name
                : "dosya_" + i + "." + Mixins.getFileExtension(evrak.evrak.type);

            const anaEvrakId = (new Date()).getTime();
            const anaEvrakFileId = fileCounter;

            const item: any = {
                id: anaEvrakId,
                evrakTuruOptionDVO: {
                    tur: evrak.tur,
                    label: evrak.turAciklama,
                    max: 1,
                    ekEvrakMax: 5,
                    sablonTurKodu: "",
                    acceptTypeList: evrak.acceptTypeList,
                    ekEvrakAcceptTypeList: ekEvrakTurList
                },
                tur: evrak.tur,
                turAciklama: evrak.turAciklama,
                file: {},
                path: "C:/fakepath/" + evrakName,
                kullaniciEvrakAciklama: evrak.aciklama,
                parentId: -1,
                isVekalet: false,
                isVekaletBilgiFormu: false,
                fileId: anaEvrakFileId
            };

            if (evrak.mandatory) {
                item.mandatory = true;
            }

            items.push(item);
            form.append("file_" + anaEvrakFileId, evrak.evrak, evrakName);
            fileCounter++;

            evrak.dosyaEkEvrak.forEach((ekEvrak: any, ekIndex: number) => {
                const ekEvrakFileId = fileCounter;
                const ekEvrakName = ekEvrak.name || ("ek_dosya_" + ekEvrakFileId + "." + Mixins.getFileExtension(ekEvrak.type));
                items.push({
                    id: (new Date()).getTime(),
                    evrakTuruOptionDVO: {
                        tur: evrak.tur,
                        label: evrak.turAciklama + " - Ek Evrak",
                        max: 1,
                        ekEvrakMax: 5,
                        sablonTurKodu: "",
                        acceptTypeList: defaultTurList,
                        ekEvrakAcceptTypeList: ekEvrakTurList
                    },
                    tur: evrak.tur,
                    turAciklama: evrak.turAciklama + " - Ek Evrak EK " + (ekIndex + 1),
                    file: {},
                    path: "C:/fakepath/" + ekEvrakName,
                    kullaniciEvrakAciklama: "",
                    parentId: anaEvrakId,
                    isVekalet: false,
                    isVekaletBilgiFormu: false,
                    fileId: ekEvrakFileId
                });
                form.append("file_" + ekEvrakFileId, ekEvrak, ekEvrakName);
                fileCounter++;
            });
        });

        form.append("items", JSON.stringify(items));
        form.append("dosyaId", tevziDosyaId);
        return form;
    }

    getDayanaklarBlobArray(): Blob[] {
        return this.dayanaklar;
    }

    getVekaletBlob() {
        return this.vekalet;
        /*
        if (typeof this.par.vekalet.data == "string") {
            this.vekalet.data = this.vekalet.data.replace('<!--[CDATA[', '').replace(']]-->', '');
        }
        let vekaletB64 = this.vekalet.data;
        //vekalet base64 olarak geldiyse
        if (typeof vekaletB64 == "string" && vekaletB64.indexOf(',') > 0) {
            vekaletB64 = this.vekalet.data.split(',')[1];
        }
        // eslint-disable-next-line no-console
        console.log("this.vekalet",this.vekalet);
        console.log("this.imzaliUdf",this.imzaliUdf);
        this.vekaletBlob = Mixins.b64toBlob(vekaletB64, this.vekalet.mimeType);
        //application/octet-stream
        console.log("VEKALET BLOB",this.vekaletBlob);
         */
    }

    convertToISOFormat(dateStr: string) {
        // dateStr -> 09/05/2024 10:43:06
        const parts = dateStr.split(" "); // Boşluklardan böl
        const dateParts = parts[0].split("/"); // Tarihi '/' işaretlerinden böl
        const timeParts = parts[1].split(":"); // Saati ':' işaretlerinden böl

        const isoDateStr = `${dateParts[2]}-${dateParts[1]}-${
            dateParts[0]
        }T${timeParts.join(":")}`;
        return isoDateStr;
    }

    async dokumanImzala(): Promise<void> {
        //app.$imza.setSimulator();
        if(app.$store.getters.isEicraproDevMode){
            this.imzaliUdf = new Blob();
        }else{

            this.addMessage("info", "Takip talebi imzalanıyor.")

            //todo imzasiz udf bossa indir.

            let imzaliUdf = await app.$imza.dokumanImzala(this.imzasizUdf);
            this.addMessage('success', 'Takip talebi imzalandı')
            let imzaliUdfBlob: Blob = app.$uyapHelper.base64toBlob(imzaliUdf, "application/octet-stream");
            console.log("Dokuman Imzalandi", imzaliUdfBlob);
            const imzasizName =
                this.imzasizUdf &&
                typeof (this.imzasizUdf as File).name === "string"
                    ? (this.imzasizUdf as File).name.trim()
                    : "";
            const resolvedTakipTalebiName =
                imzasizName !== "" ? imzasizName : "takip_talebi.udf";
            this.imzaliUdf = new File([imzaliUdfBlob], resolvedTakipTalebiName, {
                type: "application/octet-stream",
            });

        }

    }
}

